module.exports = __webpack_public_path__ + "static/media/smileRating4.da14cd6a.svg";